module.exports = __webpack_public_path__ + "static/img/join-yx3.e5d1bd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/join-yx3.png
// module id = 1MSX
// module chunks = 1